<template>
  <!-- ======= Header ======= -->
  <header id="header" class="fixed-top ">
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
          <div class="container-fluid">
            <a class="navbar-brand" href="/">{{ namasite }}</a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item"><a class="nav-link" aria-current="page" href="/">Beranda</a></li>
                <!-- <li class="nav-item"><a class="nav-link" href="/about#about">Tentang</a></li> -->
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Tahlil
                  </a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="/surat/yasin">Yasin</a></li>
                    <li><a class="dropdown-item" href="/tahlil#tahlil">Tahlil</a></li>
                    <li><a class="dropdown-item" href="/doatahlil#doatahlil">Doa Tahlil</a></li>
                  </ul>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Surat dan Keutamannya
                  </a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="/surat/rahman/">Ar-Rahman</a></li>
                    <li><a class="dropdown-item" href="/surat/waqiah">Al-Wâqi‘ah</a></li>
                    <li><a class="dropdown-item" href="/surat/mulk">Al-Mulk</a></li>
                  </ul>
                </li>
                <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Doa Masyhur
                  </a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="/doa/kumail/">Doa Kumail</a></li>
                    <li><a class="dropdown-item" href="/doa/tawassul">Doa Tawassul</a></li>
                    <li><a class="dropdown-item" href="/doa/jausyan">Jausyan Kabir</a></li>
                  </ul>
                </li>
                <!-- <li class="nav-item"><a class="nav-link" href="/team#team">Team</a></li>
                <li class="nav-item"><a class="nav-link" href="/contact#contact">Contact</a></li> -->
                <li class="nav-item"><a class="nav-link" href="/setting">Setting</a></li>
                <li class="nav-item"><a class="nav-link" href="https://www.agiptek.com/2023/03/dokumentasi-ab-tahlil.html#cara" target="_blank">Cara Penggunaan</a></li>
              </ul>
              <form class="d-flex" role="search">
                <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
                <button class="btn btn-outline-success" type="submit">Search</button>
              </form>
            </div>
          </div>
        </nav>
  </header><!-- End Header --> 

</template>

<script>
export default {
  name: 'Header',
  props: {
    namasite: String,
    selamatDatang: String,
    judul: String,
    deskripsi: String
  },
  methods: {
    scrollFix: function(hashbang){
      location.hash = hashbang;
    }
  },
  mounted() {
    location.hash = '#';
  }
}
</script>